import { UniversalBoolHelper } from '@biteinc/helpers-universal';
export const withOverride = UniversalBoolHelper.withOverride;
export const optionalDictWithOverride = UniversalBoolHelper.optionalDictWithOverride;
//# sourceMappingURL=bool_helper.js.map